import {LOAD_VEHICLE_DATA, DELETE_A_VEHICLE, SAVE_A_VEHICLE, UPDATE_A_VEHICLE,CLEAR_A_VEHICLE_ERROR_MESSAGE} from './actions';


const initialState = {
  vehiclesArray:[],
    deleteVehicleResp:{},
    errorCMsg:{},
    saveVehicleResp:{},
    updateVehicleResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_VEHICLE_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_VEHICLE_DATA:
          return Object.assign({}, state, {
              vehiclesArray: action.vehiclesData,
              errorCMsg: action.errorMsg
          });
          case DELETE_A_VEHICLE:
          return Object.assign({}, state, {
              deleteVehicleResp: action.deleteVehicleResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_VEHICLE:
          return Object.assign({}, state, {
              saveVehicleResp: action.saveVehicleResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_VEHICLE:
          return Object.assign({}, state, {
              updateVehicleResp: action.saveVehicleResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
